<template>
  <div id="app" ref="app">
    <div class="container" id="ruler-container"><div class="row"><div class="col-sm-6"></div><div class="col-md-6"></div><div class="col-lg-6"></div></div></div>
    <b-alert :show="alert.message?5:false"
             :variant="alert.type"
             dismissible
             fade
             @dismissed="clearAlert"
    >{{alert.message}}
    </b-alert>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data: () => ({
    msgServer: null,
    sseSource: undefined,
  }),
  beforeDestroy() {
    if (this.msgServer) {
      this.msgServer.close();
    }
  },
  created() {
    let storedUser = localStorage.getItem('user');
    if (storedUser) {
      storedUser = JSON.parse(storedUser);
      this.$store.dispatch('campaigns/getHolidays');
      if (storedUser.login_type) {
        this.$store.dispatch('app/runApp');
      } else {
        this.$store.dispatch('app/runApp');
        this.$store.dispatch('refs/getAll');
      }
    }

    this.$root.$on('bv::modal::shown', this.handleModalOpen);
  },
  methods: {
    clearAlert() {
      this.$store.dispatch('alert/clear');
    },
    handleModalOpen(bvEvent) {
      if (
        !(
          bvEvent.vueTarget.$attrs['fixed-header'] &&
          this.$store.state.app.isMobile
        )
      )
        return;
      const modalWindow = document.querySelector('body>[id$="modal_outer_"]');
      if (!modalWindow) {
        return;
      }

      const modalHeader = modalWindow.querySelector('.modal-header');
      modalHeader.classList.add('fixed-pos');

      const modalContent = modalWindow.querySelector('.modal-content');
      if (modalContent) {
        modalContent.style.paddingTop = modalHeader.offsetHeight + 'px';
      }
    },
  },
  computed: {
    alert() {
      console.log('this.$store.state.alert',this.$store.state.alert);
      return this.$store.state.alert;
    },
  },
  watch: {
    $route() {
      // clear alert on location change
      this.$store.dispatch('alert/clear');
    },
  },
};
</script>
